// extracted by mini-css-extract-plugin
export default {"separatorAdditionalText":"baRAqUejmVy1hc9rTmZQ","participantsStats":"vRRPjSNn88QwnoRorTO3","noMarginBottom":"xIizukeK5p60LDhSi52g"};